import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import Screen from "../../components/Screen";
import Branches from "../profile/Branches";
import { STANDALONE_FEATURES } from "../../utils/standaloneFeatures";
import resolveCompanyId from "../../utils/resolveCompanyId";

const ManageSitesPage = () => {
  const [query] = useSearchParams();
  const { user, isCompany } = useAuth();

  const isUserReady = Boolean(user?._id);
  const companyID =
    resolveCompanyId(query.get("companyID")) ||
    resolveCompanyId(localStorage.getItem("companyID")) ||
    (isCompany ? resolveCompanyId(localStorage.getItem("_id")) : null);

  const company = useMemo(
    () => (companyID ? { _id: companyID } : null),
    [companyID],
  );
  const activeTab = "#profile-manage-branches";

  return (
    <Screen
      loading={!isUserReady || !companyID}
      standaloneTitle={STANDALONE_FEATURES.MANAGE_SITES.title}
      flow={[{ label: STANDALONE_FEATURES.MANAGE_SITES.title, to: STANDALONE_FEATURES.MANAGE_SITES.path }]}
    >
      <section className="section profile">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body pt-3">
                {companyID ? <Branches company={company} tab={activeTab} /> : null}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Screen>
  );
};

export default ManageSitesPage;
